import styled from "styled-components";
import { Col } from "antd";

export default styled( Col ) `

`;